import type { PermissionExpr } from './check'
import { SECURITY_PERMISSIONS } from './security'

/**
 * Literais das permissions das abas de `/admin/empresa` — uma por aba (§31.3 do changelog do back).
 * Existe como const porque o contract test de `literals.test.ts` só alcança CONSTS, e `check.ts` faz
 * `includes()` exato: literal errado é fail-closed e MUDO.
 *
 * Todas runtime-only, fora de todo preset (`sub_roles/defaults.py`; `channels:integration:read` em
 * `permissions.py:160-165`). `channels:integration:manage` (reinscrever webhooks) NÃO está aqui: a ação
 * ficou fora da tela (D3).
 */
export const EMPRESA_PERMISSIONS = {
  /** `GET /settings/profile`. */
  PROFILE_READ: 'settings:profile:read',
  /** `PATCH /settings/profile`. O back NÃO exige a :read junto — mas a tela sem :read não mostra form. */
  PROFILE_MANAGE: 'settings:profile:manage',
  /** `GET`/`PATCH /settings/sending` — a MESMA nas duas, não existe :read. */
  SENDING_MANAGE: 'settings:sending:manage',
  /** `GET /whatsapp/account/health` e `/events`. */
  INTEGRATION_READ: 'channels:integration:read',
  /** `GET`/`PUT`/`DELETE /integrations/omnicare/credentials` — inclusive o GET de status. */
  OMNICARE_MANAGE: 'integrations:manage',
} as const

/** Entrada da tela (nav/hub): OR das seis — as cinco das abas sem gate + a de leitura das políticas (aba Segurança, faixa 28). */
export const EMPRESA_ACCESS: PermissionExpr = {
  or: [
    EMPRESA_PERMISSIONS.PROFILE_READ,
    EMPRESA_PERMISSIONS.PROFILE_MANAGE,
    EMPRESA_PERMISSIONS.SENDING_MANAGE,
    EMPRESA_PERMISSIONS.INTEGRATION_READ,
    EMPRESA_PERMISSIONS.OMNICARE_MANAGE,
    SECURITY_PERMISSIONS.POLICIES_READ,
  ],
}
